import { Tag } from '@chakra-ui/react';
import { BsClockFill } from 'react-icons/bs';
import { MdLock } from 'react-icons/md';
import { MIcon, MTooltip } from '../../../../components/Monetize';

export const SubscriptionHeaderTag = (
  isLocked: boolean,
  hasScheduledChanges: boolean,
) => {
  if (isLocked && !hasScheduledChanges) {
    return (
      <MTooltip
        contentProps={{ mt: 3, ml: 12 }}
        label="This subscription is part of a contract"
        shouldWrapChildren
        placement="bottom-start"
      >
        <span>
          <MIcon
            data-testid="subscription-locked-icon"
            w={4}
            h={6}
            ml="3"
            as={MdLock}
            fontSize="xl"
            alignSelf="center"
            style={{
              cursor: 'pointer',
            }}
          />
        </span>
      </MTooltip>
    );
  }
  if (hasScheduledChanges) {
    return (
      <Tag.Root
        backgroundColor="tGray.back"
        color="tPurple.dark"
        fontWeight={400}
      >
        <Tag.StartElement boxSize="12px" asChild>
          <BsClockFill />
        </Tag.StartElement>
        <Tag.Label>Scheduled Changes</Tag.Label>
      </Tag.Root>
    );
  }
  return null;
};
